<script lang="ts">
  import { _ } from 'svelte-i18n'
  const { code, language = '' } = $props<{ code: string; language?: string }>()
  let copied = $state(false)

  async function copy() {
    await navigator.clipboard.writeText(code)
    copied = true
    setTimeout(() => copied = false, 2000)
  }
</script>

<div class="group relative rounded-lg overflow-hidden border border-edge my-3">
  <div class="flex items-center justify-between px-4 py-1.5 bg-code-surface border-b border-edge">
    <span class="text-[10px] uppercase tracking-wider text-muted">{language || 'text'}</span>
    <button
      onclick={copy}
      class="text-[10px] text-muted hover:text-foreground transition-colors px-2 py-0.5 rounded hover:bg-surface-hover"
    >
      {copied ? '✓ Скопировано' : $_('chat.code_block.kopirovat')}
    </button>
  </div>
  <pre class="overflow-x-auto p-4 bg-code-surface text-sm leading-relaxed"><code class="language-{language} text-foreground">{code}</code></pre>
</div>
